import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_date_technical } from '../../functions/functions_formatting.js';


export default class Saleslist extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {

        return (
            <div className="admindashboard__section">
                <div className="admindashboard__section__title text-title">
                    Sales
                </div>
                <div className="admindashboard__section__content">
                    {(this.props.data && this.props.data.length >= 1) &&
                        <div className="admindashboard__section__content__table admindashboard__section__content__table--sales">

                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Trip ID
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Buyer ID
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Buyer username
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Amount net
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Fees
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Status
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Created
                            </div>

                            {this.props.data.map((el, i) => (
                                <React.Fragment key={i}>
                                    <div onClick={() => this.props.setTrip(el.order.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                        {el.order.trip_id ? el.order.trip_id : "-"}
                                    </div>
                                    <div onClick={() => this.props.setUser(el.order.buyer_user_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                        {el.order.buyer_user_id ? el.order.buyer_user_id : "-"}
                                    </div>
                                    <Link to={"/u/" + el.order.buyer_username} className="admindashboard__section__content__table__element">
                                        {el.order.buyer_username ? el.order.buyer_username : "-"}
                                    </Link>
                                    <div className="admindashboard__section__content__table__element">
                                        {el.amount_net ? el.amount_net : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {el.fee ? el.fee : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {el.order.status ? el.order.status : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {format_date_technical(el.created)}
                                    </div>
                                </React.Fragment>
                            ))}

                        </div>
                    }
                </div>
            </div>
        )
    }
}